import { useEffect } from 'react';

import { Api } from 'src/models/Api.model';

import { useConnectionRetry } from 'src/hooks/useConnectionRetry';

import ConnectionIssueModal from './ConnectionIssueModal';
import ConnectionRestoredModal from './ConnectionRestoredModal';

type ConnectionIssueControllerProps = {
  show: boolean;
  onConnectionRestored: () => void;
  secondaryButton?: React.ReactNode;
  checkConnection?: () => Promise<boolean>;
};

export default function ConnectionIssueController({
  show,
  onConnectionRestored,
  secondaryButton,
  checkConnection = Api.remote.check_galen_connection,
}: ConnectionIssueControllerProps) {
  const {
    reconnectionStatus,
    isCheckingConnection,
    handleCheckConnection,
    resetReconnectionStatus,
  } = useConnectionRetry(checkConnection);

  useEffect(() => {
    if (!show) resetReconnectionStatus();
  }, [show, resetReconnectionStatus]);

  if (reconnectionStatus) {
    return (
      <ConnectionRestoredModal show={show} onClose={onConnectionRestored} />
    );
  }

  return (
    <ConnectionIssueModal
      show={show}
      shouldShowCard={reconnectionStatus === false}
      isCheckingConnection={isCheckingConnection}
      handleCheckConnection={handleCheckConnection}
      secondaryButton={
        reconnectionStatus === false ? secondaryButton : undefined
      }
    />
  );
}
